module.exports = {
    path: '/coldstart',
    meta: { module: 'cs' },
    component: () => import('@cs/App'),
    children: [
        {
            path: '',
            name: 'cs-countries',
            component: () => import('@cs/views/Countries'),
            meta: {
                type: 'countries'
            }
        },
        {
            path: 'countries/:countryId',
            name: 'cs-sites',
            component: () => import('@cs/views/Sites'),
            meta: {
                type: 'sites'
            }
        },
        {
            path: 'countries/:countryId/sites/:siteId',
            name: 'cs-summary',
            component: () => import('@cs/views/SiteSummary'),
            meta: {
                type: 'assets'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/coldstart/router.js